var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"register"},[_c('NavBar',{attrs:{"registerPage":true}}),_c('v-main',[_c('RegisterForm',{attrs:{"provider":_vm.provider}})],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }